




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class EmailLink extends Vue {
  @Prop({ default: 'Email Me' })
  private label: string;

  @Prop({ default: 'yaroslav.berkut@gmail.com' })
  private emailTo: string;

  @Prop({ default: '' })
  private subject: string;

  @Prop({ default: '' })
  private body: string;

  get href() {
    return `mailto:${encodeURIComponent(this.emailTo)}`
      + `?subject=${encodeURIComponent(this.subject)}`
      + `&body=${encodeURIComponent(this.body)}`;
  }
}
